import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/api/client";
import Layout from "@/components/Layout";
import Modal from "@/components/Modal";
import { fmtDateTime, productLabel } from "@/lib/format";
import { toast } from "sonner";
import { IDS } from "@/constants/testIds";

const emptyM = { variant_id: "", type: "Carico", qty: 1, note: "" };

export default function Movimenti() {
  const [products, setProducts] = useState([]);
  const [variants, setVariants] = useState([]);
  const [movements, setMovements] = useState([]);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState(emptyM);

  const load = async () => {
    const [p, v, m] = await Promise.all([api.get("/products"), api.get("/variants"), api.get("/movements")]);
    setProducts(p.data); setVariants(v.data); setMovements(m.data);
  };
  useEffect(() => { load(); }, []);

  const variantLabel = (id) => {
    const v = variants.find((x) => x.id === id);
    if (!v) return "Variante eliminata";
    return `${productLabel(products, v.product_id)} · ${v.color || "N/D"} · ${v.size || "N/D"}`;
  };

  const save = async () => {
    if (!form.variant_id) return toast.error("Seleziona una variante");
    try {
      await api.post("/movements", { ...form, qty: Math.abs(+form.qty || 0) });
      toast.success("Movimento registrato"); setModal(false); setForm(emptyM); load();
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };

  return (
    <Layout topbarActions={
      <button className="btn accent" onClick={() => setModal(true)} data-testid={IDS.newMovementBtn}>
        <i className="fa-solid fa-plus" /> Registra movimento
      </button>
    }>
      <div className="section-title">
        <div><h2>Movimenti</h2><p>Storico carichi, scarichi e rettifiche di magazzino.</p></div>
      </div>
      <div className="panel">
        <div className="table-wrap">
          <table>
            <thead><tr><th>Data</th><th>Tipo</th><th>Variante</th><th>Quantità</th><th>Nota</th></tr></thead>
            <tbody data-testid="movements-table-body">
              {movements.length ? movements.map((m) => (
                <tr key={m.id}>
                  <td>{fmtDateTime(m.date)}</td>
                  <td><span className={`pill ${m.type === "Scarico" || m.type === "Rettifica negativa" ? "warn" : "ok"}`}>{m.type}</span></td>
                  <td>{variantLabel(m.variant_id)}</td>
                  <td>{m.qty > 0 ? "+" : ""}{m.qty}</td>
                  <td>{m.note || "—"}</td>
                </tr>
              )) : (
                <tr><td colSpan={5} className="empty">Nessun movimento registrato.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal open={modal} title="Movimento di magazzino" onClose={() => setModal(false)} onSave={save}>
        {variants.length ? (
          <div className="form-grid">
            <div className="field full"><label>Variante *</label>
              <select value={form.variant_id} onChange={(e) => setForm({ ...form, variant_id: e.target.value })}>
                <option value="">— seleziona —</option>
                {variants.map((v) => <option key={v.id} value={v.id}>{variantLabel(v.id)} (SKU {v.sku})</option>)}
              </select>
            </div>
            <div className="field"><label>Tipo</label>
              <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
                <option>Carico</option><option>Scarico</option>
                <option>Rettifica positiva</option><option>Rettifica negativa</option>
              </select>
            </div>
            <div className="field"><label>Quantità *</label><input type="number" min="1" value={form.qty} onChange={(e) => setForm({ ...form, qty: e.target.value })} /></div>
            <div className="field full"><label>Nota</label><textarea rows="3" value={form.note} onChange={(e) => setForm({ ...form, note: e.target.value })} /></div>
          </div>
        ) : <div className="empty">Prima crea almeno una variante di magazzino.</div>}
      </Modal>
    </Layout>
  );
}
